// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".floating-button-add {\n  position: fixed;\n  bottom: 3rem;\n  right: 4rem;\n  color: var(--color-primary);\n  cursor: pointer;\n  z-index: 1;\n}\n\n@media (max-width: 900px) {\n  .floating-button-add {\n    right: 2rem;\n  }\n\n  .floating-button-add svg {\n    width: 3.5em;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
